/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Select_YearInputs */

const fr_calendar_select_year = /** @type {(inputs: Calendar_Select_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir l’année`)
};

const en_calendar_select_year = /** @type {(inputs: Calendar_Select_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose year`)
};

/**
* | output |
* | --- |
* | "Choose year" |
*
* @param {Calendar_Select_YearInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_select_year = /** @type {((inputs?: Calendar_Select_YearInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Select_YearInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_select_year(inputs)
	return fr_calendar_select_year(inputs)
});